function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { isBrowser } from '@finect/front-utils/isBrowser';
import { FinectLogo } from '../../FinectLogo';
export function Watermark(HC) {
  var H = HC;
  var ratioCache = H.__watermarkRatioCache = H.__watermarkRatioCache || new Map();
  function svgToDataUri(svgString) {
    var svg = svgString.startsWith('<svg') ? svgString : "<svg xmlns=\"http://www.w3.org/2000/svg\">".concat(svgString, "</svg>");
    var encoded = encodeURIComponent(svg).replace(/'/g, '%27').replace(/"/g, '%22');
    return "data:image/svg+xml;charset=UTF-8,".concat(encoded);
  }
  var DEFAULT_IMAGE_URI;
  function computeDefaultFinectLogoUri() {
    if (!isBrowser()) return null;
    if (DEFAULT_IMAGE_URI !== undefined) return DEFAULT_IMAGE_URI || null;
    try {
      var svg = ReactDOMServer.renderToStaticMarkup(React.createElement(FinectLogo, null));
      DEFAULT_IMAGE_URI = svgToDataUri(svg);
      return DEFAULT_IMAGE_URI;
    } catch (_unused) {
      DEFAULT_IMAGE_URI = null;
      return null;
    }
  }
  function resolveDefaultImage() {
    var injected = H.Watermark && H.Watermark.defaultImage;
    if (injected) return injected;
    var globalWin = isBrowser() ? window : undefined;
    if (globalWin && globalWin.__WATERMARK_DEFAULT_IMAGE__) {
      return globalWin.__WATERMARK_DEFAULT_IMAGE__;
    }
    return computeDefaultFinectLogoUri();
  }
  function getPlotBox(chart) {
    var plotLeft = chart.plotLeft,
      plotTop = chart.plotTop,
      plotWidth = chart.plotWidth,
      plotHeight = chart.plotHeight;
    return {
      x: plotLeft,
      y: plotTop,
      width: plotWidth,
      height: plotHeight
    };
  }
  function getWatermarkOptions(chart) {
    var _o$chart, _u$chart;
    var o = chart.options || {};
    var u = chart.userOptions || {};
    return o.watermark || ((_o$chart = o.chart) === null || _o$chart === void 0 ? void 0 : _o$chart.watermark) || u.watermark || ((_u$chart = u.chart) === null || _u$chart === void 0 ? void 0 : _u$chart.watermark) || undefined;
  }
  function resolvePosition(box, align, verticalAlign, width, height) {
    var dx = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    var dy = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    var x = box.x + (box.width - width) / 2;
    var y = box.y + (box.height - height) / 2;
    if (align === 'left') x = box.x;
    if (align === 'right') x = box.x + box.width - width;
    if (verticalAlign === 'top') y = box.y;
    if (verticalAlign === 'bottom') y = box.y + box.height - height;
    return {
      x: Math.round(x + dx),
      y: Math.round(y + dy)
    };
  }
  function ensureImageRatio(src, chart) {
    if (!src || ratioCache.has(src) || !isBrowser()) return;
    chart.__wmLoading = chart.__wmLoading || {};
    if (chart.__wmLoading[src]) return;
    chart.__wmLoading[src] = true;
    var img = new Image();
    var cleanup = function cleanup() {
      var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      try {
        ratioCache.set(src, ratio);
        if (chart && chart.__wmLoading && _typeof(chart.__wmLoading) === 'object') {
          chart.__wmLoading[src] = false;
        }
        if (chart && typeof chart.redraw === 'function' && !chart.isDestroyed) {
          chart.redraw();
        }
      } catch (error) {
        console.warn('Watermark cleanup error:', error);
      }
    };
    img.onload = function () {
      var w = img.naturalWidth || img.width || 0;
      var h = img.naturalHeight || img.height || 0;
      var ratio = w > 0 && h > 0 ? w / h : 1;
      cleanup(ratio);
    };
    img.onerror = function () {
      cleanup(1);
    };
    img.src = src;
  }
  H.addEvent(H.Chart, 'render', function () {
    var chart = this;
    var baseOpts = getWatermarkOptions(chart) || {};
    var r = chart.renderer;
    var image = baseOpts.image;
    var text = baseOpts.text;
    if (!image && !text) image = resolveDefaultImage();
    var hasContent = Boolean(image || text);
    var isEnabled = typeof baseOpts.enabled === 'boolean' ? baseOpts.enabled : hasContent;
    if (!isEnabled || !hasContent) {
      var _chart$watermarkEl;
      (_chart$watermarkEl = chart.watermarkEl) === null || _chart$watermarkEl === void 0 ? void 0 : _chart$watermarkEl.destroy();
      chart.watermarkEl = null;
      return;
    }
    var _baseOpts$opacity = baseOpts.opacity,
      opacity = _baseOpts$opacity === void 0 ? 0.35 : _baseOpts$opacity,
      _baseOpts$rotation = baseOpts.rotation,
      rotation = _baseOpts$rotation === void 0 ? 0 : _baseOpts$rotation,
      _baseOpts$align = baseOpts.align,
      align = _baseOpts$align === void 0 ? 'right' : _baseOpts$align,
      _baseOpts$verticalAli = baseOpts.verticalAlign,
      verticalAlign = _baseOpts$verticalAli === void 0 ? 'bottom' : _baseOpts$verticalAli,
      width = baseOpts.width,
      height = baseOpts.height,
      _baseOpts$x = baseOpts.x,
      x = _baseOpts$x === void 0 ? -8 : _baseOpts$x,
      _baseOpts$y = baseOpts.y,
      y = _baseOpts$y === void 0 ? -24 : _baseOpts$y,
      _baseOpts$mobileBreak = baseOpts.mobileBreakpoint,
      mobileBreakpoint = _baseOpts$mobileBreak === void 0 ? 500 : _baseOpts$mobileBreak,
      _baseOpts$mobileScale = baseOpts.mobileScale,
      mobileScale = _baseOpts$mobileScale === void 0 ? 0.75 : _baseOpts$mobileScale,
      _baseOpts$style = baseOpts.style,
      style = _baseOpts$style === void 0 ? {} : _baseOpts$style;
    var plot = getPlotBox(chart);
    var base = Math.max(40, Math.min(plot.width, plot.height) * 0.18);
    var h = height || base;
    var isMobile = (chart.chartWidth || 0) <= mobileBreakpoint;
    var scale = isMobile ? Math.max(0, Math.min(1, mobileScale)) : 1;
    if (image) {
      if (!ratioCache.has(image)) {
        if (!isBrowser()) ratioCache.set(image, 1);
        ensureImageRatio(image, chart);
        if (!ratioCache.has(image)) return;
      }
      var ratio = ratioCache.get(image) || 1;
      var hEff = Math.max(24, Math.round(h * scale));
      var wEff = width ? Math.round(width * scale) : Math.round(hEff * ratio);
      if (!chart.watermarkEl || chart.watermarkEl.element.tagName !== 'image') {
        var _chart$watermarkEl2, _chart$watermarkEl$to, _chart$watermarkEl3;
        (_chart$watermarkEl2 = chart.watermarkEl) === null || _chart$watermarkEl2 === void 0 ? void 0 : _chart$watermarkEl2.destroy();
        chart.watermarkEl = r.image(image, 0, 0, wEff, hEff).add();
        chart.watermarkEl.css({
          pointerEvents: 'none'
        });
        (_chart$watermarkEl$to = (_chart$watermarkEl3 = chart.watermarkEl).toBack) === null || _chart$watermarkEl$to === void 0 ? void 0 : _chart$watermarkEl$to.call(_chart$watermarkEl3);
      }
      var pos = resolvePosition(plot, align, verticalAlign, wEff, hEff, x, y);
      chart.watermarkEl.attr({
        x: pos.x,
        y: pos.y,
        width: wEff,
        height: hEff,
        opacity: opacity,
        rotation: rotation,
        zIndex: 0
      });
      return;
    }
    if (text) {
      if (!chart.watermarkEl || chart.watermarkEl.element.tagName !== 'text') {
        var _chart$watermarkEl4, _chart$watermarkEl$to2, _chart$watermarkEl5;
        (_chart$watermarkEl4 = chart.watermarkEl) === null || _chart$watermarkEl4 === void 0 ? void 0 : _chart$watermarkEl4.destroy();
        chart.watermarkEl = r.text(text, 0, 0).css(_objectSpread({
          pointerEvents: 'none',
          fontSize: '32px',
          fontWeight: 'bold',
          fill: 'currentColor',
          color: '#000'
        }, style)).add();
        (_chart$watermarkEl$to2 = (_chart$watermarkEl5 = chart.watermarkEl).toBack) === null || _chart$watermarkEl$to2 === void 0 ? void 0 : _chart$watermarkEl$to2.call(_chart$watermarkEl5);
      }
      var bbox = chart.watermarkEl.getBBox();
      var tw = width || bbox.width;
      var th = height || bbox.height;
      var _pos = resolvePosition(plot, align, verticalAlign, tw, th, x, y);
      chart.watermarkEl.attr({
        x: _pos.x,
        y: _pos.y,
        opacity: opacity,
        rotation: rotation,
        zIndex: 0
      });
    }
  });
  H.addEvent(H.Chart, 'destroy', function () {
    var _this$watermarkEl;
    (_this$watermarkEl = this.watermarkEl) === null || _this$watermarkEl === void 0 ? void 0 : _this$watermarkEl.destroy();
    this.watermarkEl = null;
  });
}